<template>
    <div>
        <div class="modal fade" id="enquenteAplicadaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Enquetes</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!model">
                            <az-empty-state msg="Item não identificado." />
                        </template>

                        <template v-else-if="enquete_aplicada">
                            <az-sub-title :title="( enquete_aplicada.id_enquete_aplicada ? 'Respondida: ' : 'Responder: ' ) + enquete_aplicada.enquete.st_titulo">
                                <a href="#" @click.prevent="enquete_aplicada = null">
                                    <i class="fa-solid fa-angle-left"></i>
                                </a>
                            </az-sub-title>

                            <az-input 
                                v-if="enquete_aplicada.id_enquete_aplicada"
                                type="checkbox-group"
                                label="Ativa"
                                sizing="sm"
                                v-model="enquete_aplicada.fl_ativo" />

                            <formulario
                                :compact="enquete_aplicada.enquete.fl_compact"
                                :validate="validate"
                                :block_modelos="true"
                                v-model="enquete_aplicada.js_respostas"
                                :saved="true"
                                :mode="1==1 ? 'fixed' : 'view'">
                            </formulario>

                            <pre v-if="false">{{ enquete_aplicada }}</pre>
                        </template>

                        <template v-else>
                            <div class="mb-3">
                                <az-sub-title title="Respondidas" />
                                <div class="list-group" v-if="model.model && model.model.enquetes_aplicadas && model.model.enquetes_aplicadas.length">
                                    <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(aplic, iax) in model.model.enquetes_aplicadas" :key="iax" @click="editar(aplic)">
                                        <div>
                                            {{ aplic.enquete.st_titulo }}, em {{ $util.getFormatDate(aplic.created_at) }} {{ aplic.created_at.slice(11,16) }}, por {{ aplic.usuario.st_login }}
                                        </div>
                                        <div>
                                            <span class="badge" :class="'badge-' + ( aplic.st_cor ? aplic.st_cor : 'secondary' )" v-if="aplic.st_conceito">{{ aplic.st_conceito }}</span>
                                            <span class="badge badge-secondary ml-1" v-if="aplic.in_score || aplic.in_score === 0">{{ aplic.in_score }}</span>
                                        </div>
                                    </button>
                                </div>

                                <div v-else>
                                    Nenhuma resposta registrada.
                                </div>
                            </div>

                            <div class="mb-3" v-if="model.enquetes">
                                <az-sub-title title="Enquetes Disponíveis" />
                                <div class="list-group" v-if="model.enquetes">
                                    <button type="button" class="list-group-item list-group-item-action" v-for="(enquete, iex) in model.enquetes" :key="iex" @click="responder(enquete)">
                                        {{ enquete.st_titulo }}
                                    </button>
                                </div>

                                <div v-else>
                                    Nenhuma enquete disponível.
                                </div>
                            </div>
                        </template>

                        <pre v-if="false">{{ model }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="enquete_aplicada" @click="atualizar()">{{ enquete_aplicada.id_enquete_aplicada ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubTitle from '../util/AzSubTitle.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzSubmit from '../util/AzSubmit.vue';
import Formulario from '../modulos/consultorio/Formulario.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            model: null, 
            enquete_aplicada: null, 
            info: null, 
            validate: false, 
        };
    },

    components: { 
        AzSubTitle, 
        AzEmptyState,
        AzSubmit, 
        Formulario, 
        AzInput, 
    },

    methods: { 
        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'enquetes_aplicadas',
                func: 'store',
                dados: this.enquete_aplicada, 
                toast: true, 
                modal: 'enquenteAplicadaModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            })
        },

        responder (enquete) { 
            this.validate = false; 

            this.enquete_aplicada = { 
                id_enquete_aplicada: null, 
                id_enquete: enquete.id_enquete,
                fl_ativo: true, 
                enquete: _.cloneDeep(enquete), 
                js_respostas: _.cloneDeep(enquete.js_formulario), 
                in_score: null, 
                model_type: this.parms.model_type, 
                model_id: this.parms.id, 
            };
        },

        editar(enquete_aplicada) { 
            this.enquete_aplicada = _.cloneDeep(enquete_aplicada);
        },

        abrir(model, model_type, campo_model_id) { 
            this.model = null;
            this.enquete_aplicada = null;
            this.parms = { 
                campo_model_id: campo_model_id,
                model_type: model_type,
                id: model[campo_model_id],
            };

            $('#enquenteAplicadaModal').modal('show');

            this.$util.load(this, { 
                service: 'enquetes_aplicadas',
                func: 'lista', 
                parms: this.parms,
                loadTo: res => { 
                    this.model = res;
                }
            });
        }
    }
}
</script>
